// التقاط موقع العملية لحظة تنفيذها: GPS (الأدق) + المنطقة الزمنية للجهاز.
// لا نفشل إن رُفض إذن الموقع؛ نكتفي بتوقيت الجهاز، والخادم يكشف تزوير IP/VPN.
export const actionLoc = () =>
  new Promise((resolve) => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || null;
    if (!navigator.geolocation) return resolve({ tz });
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, tz }),
      () => resolve({ tz }),
      { enableHighAccuracy: true, timeout: 8000 },
    );
  });
